import i18n from '../i18n/i18n'

export default {
  data () {
    return {
      referenceNumber: {
        text1: null,
        text2: null,
        text3: null
      },
      invalidReferenceNumber1: false,
      invalidReferenceNumber2: false,
      invalidReferenceNumber3: false
    }
  },
  watch: {
    'referenceNumber.text1' (newVal) {
      this.invalidReferenceNumber1 = false
      this.updateReferenceNumbers(newVal, 'text1')
    }
  },
  computed: {
    locale () {
      return this.$store.getters['geolocation/country']
    },
    isCrownRefFormatEnabled () {
      return this.isSystemOptionParameterEnabled('ENABLE_REF_CROWN_FORMAT')
    },
    crownReferenceNumber () {
      if (this.referenceNumber.text1 && this.referenceNumber.text2 && this.referenceNumber.text3) {
        return `${this.referenceNumber.text1}-${this.referenceNumber.text2}-${this.referenceNumber.text3}`
      }
      return ''
    },
    allowedCrownReferenceNumberChars () {
      return /[^0-9-]/g
    },
    nonNumericChars () {
      return /[^0-9]/g
    },
    invalidReferenceNumber () {
      return this.invalidReferenceNumber1 || this.invalidReferenceNumber2 || this.invalidReferenceNumber3
    }
  },
  methods: {
    getConst (locale, str) {
      return i18n(locale, str)
    },
    validateReferenceText1 (input) {
      const value = input && input.target && input.target.value
      if (!value || (value && value.length < 4 || (parseInt(value) && parseInt(value) < 1900))) {
        this.invalidReferenceNumber1 = true
      }
    },
    validateReferenceText2 (input) {
      this.invalidReferenceNumber2 = false
      const value = input && input.target && input.target.value
      if (value) {
        this.referenceNumber.text2 = value.replace(this.allowedCrownReferenceNumberChars, '')
        if (this.referenceNumber.text2.trim().length !== 5 || this.referenceNumber.text2.includes(this.nonNumericChars)) {
          this.invalidReferenceNumber2 = true
        }
      } else {
        this.invalidReferenceNumber2 = true
      }
    },
    validateReferenceText3 (input) {
      this.invalidReferenceNumber3 = false
      const value = input && input.target && input.target.value
      if (value) {
        this.referenceNumber.text3 = value.replace(this.allowedCrownReferenceNumberChars, '')
        if (this.referenceNumber.text3.trim().length !== 2 || this.referenceNumber.text3.includes(this.nonNumericChars)) {
          this.invalidReferenceNumber3 = true
        }
      } else {
        this.invalidReferenceNumber3 = true
      }
    },
    updateReferenceNumbers (newVal) {
      const numericAndDashOnly = newVal.replace(this.allowedCrownReferenceNumberChars, '')
      let firstText = numericAndDashOnly
      let secondText = ''
      let thirdText = ''
      if (numericAndDashOnly.includes('-')) {
        const split = numericAndDashOnly.split('-')
        if (split.length === 3) {
          firstText = split[0]
          secondText = split[1]
          thirdText = split[2]
        }
      }
      if (firstText && firstText.length > 4) {
        firstText = firstText.substr(0, 4)
      }
      this.referenceNumber.text1 = firstText
      if (secondText) {
        this.referenceNumber.text2 = secondText
      }
      if (thirdText) {
        this.referenceNumber.text3 = thirdText
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/quote/mixins/quotes.js